'use client';

import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination } from 'swiper/modules';
import { motion } from 'framer-motion';
import { Eye, Play, X } from 'lucide-react';

// Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

const GOLD_ACCENT = '#faaf40';

const REELS_DATA = [
  { id: 'izow3dWhwrI', views: '489k', label: 'Client Review | EMS and Pilates' },
  { id: 'tUxsJnE5af8', views: '2K', label: 'Client Review | Yasir Hameed | Former Pakistani cricketer' },
  { id: 'AQKqiqVZQa0', views: '384', label: 'Client Review | Transformation Journey' },
  { id: 'w3fzh2Si4jA', views: '384k', label: 'Client Review | Saad Hayat | Music Producer' },
  { id: 'LxLqw83Jjx4', views: '224k', label: 'Client Review | Dr Ayesha  | physiotherapist ' },
  { id: 'WXj6WBA4Jc0', views: '24k', label: 'Client Review | Dr Shania Shafi  | Chiropractor  ' },
];

export default function InfluencerReels() {
  // REMOVED: <string | null> to fix the ReferenceError in .js files
  const [playingId, setPlayingId] = useState(null);

  return (
    <section className="py-16 bg-black text-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 w-full">
        <div className="mb-10 text-center md:text-left">
          <h2 className="text-3xl sm:text-5xl font-light italic">
            INFLUENCER <span className="font-extrabold not-italic text-[#faaf40]">RECOMMENDATIONS</span>
          </h2>
        </div>

        <div className="reels-swiper-container">
          <Swiper
            modules={[FreeMode, Pagination]}
            spaceBetween={15}
            slidesPerView={1.2}
            freeMode={true}
            grabCursor={true}
            pagination={{ clickable: true, dynamicBullets: true }}
            breakpoints={{
              640: { slidesPerView: 2.5 },
              1024: { slidesPerView: 3.8 },
              1280: { slidesPerView: 4.8 },
            }}
            className="!pb-14 !overflow-visible"
          >
            {REELS_DATA.map((reel) => (
              <SwiperSlide key={reel.id}>
                <div 
                  className="relative aspect-[9/16] rounded-2xl overflow-hidden bg-zinc-900 shadow-2xl group"
                  style={{ border: `1px solid ${GOLD_ACCENT}` }}
                >
                  {/* Views Overlay */}
                  <div className="absolute top-3 left-3 z-30 bg-black/60 backdrop-blur-md px-2 py-1 rounded-md flex items-center gap-1 border border-white/10">
                    <Eye size={12} className="text-[#faaf40]" />
                    <span className="text-[10px] font-bold">{reel.views}</span>
                  </div>

                  {playingId === reel.id ? (
                    <div className="absolute inset-0 z-10 overflow-hidden bg-black">
                      {/* Close Button to return to thumbnail */}
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          setPlayingId(null);
                        }}
                        className="absolute top-3 right-3 z-40 p-1 bg-black/50 rounded-full hover:bg-black"
                      >
                        <X size={16} />
                      </button>
                      
                      <iframe
                        src={`https://www.youtube.com/embed/${reel.id}?autoplay=1&controls=0&modestbranding=1&rel=0&mute=0`}
                        className="absolute top-1/2 left-1/2 w-[450%] h-full -translate-x-1/2 -translate-y-1/2"
                        allow="autoplay; encrypted-media"
                        title={reel.label}
                      />
                    </div>
                  ) : (
                    <div className="w-full h-full" onClick={() => setPlayingId(reel.id)}>
                      {/* Thumbnail Placeholder */}
                      <img 
                        src={`https://img.youtube.com/vi/${reel.id}/maxresdefault.jpg`}
                        alt={reel.label}
                        className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-100 transition-all duration-500"
                      />
                      {/* Play Button Overlay */}
                      <div className="absolute inset-0 flex items-center justify-center z-20">
                        <div className="w-14 h-14 rounded-full bg-black/40 border border-[#faaf40]/50 flex items-center justify-center backdrop-blur-sm group-hover:scale-110 transition-transform duration-300">
                          <Play size={24} fill={GOLD_ACCENT} className="text-[#faaf40] ml-1" />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Gradient Overlay for Text */}
                  <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-black to-transparent z-10 pointer-events-none" />

                  {/* Text Overlay */}
                  <div className="absolute bottom-0 left-0 w-full p-4 z-20">
                    <p className="text-white text-[11px] font-bold uppercase tracking-tight leading-tight">
                      {reel.label}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <style jsx global>{`
        .reels-swiper-container .swiper-pagination-bullet { background: #333 !important; opacity: 1; }
        .reels-swiper-container .swiper-pagination-bullet-active { 
          background: ${GOLD_ACCENT} !important; 
          width: 20px !important; 
          height: 4px !important; 
          border-radius: 2px !important; 
        }
      `}</style>
    </section>
  );
}